var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    {
      attrs: {
        id: "contact",
        title: "How can I contact Font Awesome about privacy?",
      },
    },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [
          _vm._v(
            "\n      You can send privacy-related questions, complaints, and requests to Font Awesome at\n      "
          ),
          _c("a", { attrs: { href: "mailto:privacy@fontawesome.com" } }, [
            _vm._v("privacy@fontawesome.com"),
          ]),
          _vm._v("\n      .\n    "),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "For complaints under GDPR more generally, European Union users may lodge complaints with their local data protection supervisory authorities."
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }